import * as React from 'react';
import styled from 'styled-components';
import { TextArea } from '../../shared/form/TextArea';
import { TextField } from '../../shared/form/TextField';
import { SelectBox } from '../../shared/form/SelectBox';
import { ControlSpacer } from '../../shared/form/ControlSpacer';

interface IProps {
  updateName: (value: string) => void;
  defaultName?: string;
  updateDesc?: (value: string) => void;
  tag: {
    name: string;
    description: string;
    exclude_weight: boolean;
  };
  defaultDesc?: string;
  toggle: () => void;
}

export const TagForm = (props: IProps): React.ReactElement => {
  const { tag } = props;
  return (
    <FormContainer>
      <ControlSpacer>
        <TextField
          name='name'
          placeholder='Name'
          onChange={props.updateName}
          value={tag.name || ''}
          label={props.defaultName || 'Name'}
          type='text'
        />
      </ControlSpacer>
      <ControlSpacer>
        <TextArea
          name='description'
          placeholder={'Description'}
          onChange={props.updateDesc}
          value={tag.description || ''}
          label={props.defaultDesc || 'Description'}
        />
      </ControlSpacer>
      <ControlSpacer style={{ alignSelf: 'flex-start' }}>
        <SelectBox
          label='Exclude Weight*'
          onSelect={props.toggle}
          selected={tag.exclude_weight}
        />
      </ControlSpacer>
      <ControlSpacer>
        <HelpText>
          *Check this box if the tag represents a modification to a testing
          protocol where the athlete's weight would not be comparable (e.g. an
          added load, an upper body test or a single leg test). If this box is
          checked, tests with this tag will not be considered when reporting an
          athlete's weight.
        </HelpText>
      </ControlSpacer>
    </FormContainer>
  );
};

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const HelpText = styled.div`
  color: var(--color-secondary-text);
`;
